import { Button, IconIdentifier } from '@aus-platform/design-system';
import classNames from 'classnames';
import React, { useState } from 'react';

type PolygonAIModeToggleProps = {
  isAiModeEnabled: boolean;
  disabled?: boolean;
  onToggle: VoidFunction;
};

export const PolygonAIModeToggle: React.FC<PolygonAIModeToggleProps> = ({
  isAiModeEnabled,
  disabled,
  onToggle,
}) => {
  // States.
  const [isHovering, setIsHovering] = useState(false);

  // Classnames.
  const className = classNames('polygon-ai-mode-toggle', {
    on: isAiModeEnabled,
  });

  return (
    <Button
      className={className}
      rightIconIdentifier={IconIdentifier.SAMTool}
      onClick={onToggle}
      disabled={disabled}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {!isAiModeEnabled
        ? 'Enable AI Mode'
        : isHovering
          ? 'Disable AI Mode'
          : 'AI Mode Enabled'}
    </Button>
  );
};
